import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Workflow } from '../../models/workflow/workflow.model';
import { GlobalService } from '../../services/global.service';
import { WorkflowService } from '../../services/workflow-service';
import { AlertComponent } from '../../common/alert/alert.component';

@Component({
  selector: 'app-save-flowsheet',
  templateUrl: './save-workflow.component.html',
  styleUrls: ['./save-workflow.component.css']
})
export class SaveworkflowComponent {
  workflow = new Workflow();
  workflowList = [];
  isLoading = true;
  nameExist = true;

  constructor(public dialogRef: MatDialogRef<SaveworkflowComponent>,
    public workFlowService: WorkflowService,
    public globals: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.getWorkflowList();
  }

  getWorkflowList() {
    this.workFlowService.getWorkflowList().subscribe((data: any): void => {
      this.workflowList = data;
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Something went wrong!" });
      this.isLoading = false;
    });
  }

  validateUniqueName(event) {
    this.nameExist = false;
    let workflowName = event.target.value;
    let nameExisiting;
    nameExisiting = this.workflowList.filter((m) => { return m.workflowName == workflowName });
    this.nameExist = nameExisiting.length > 0;
  }

  saveWorkflow() {
    this.dialogRef.close(this.workflow);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}
